import React, {Component} from "react";
import {Button} from "primereact/button";
import User from "./UserView";

export default class UserContainer extends Component {
    render() {
        var headerUser =
            <div style={{textAlign: 'right'}}>
                <Button type="button" iconPos="left" label="Cargar Archivo" style={{marginRight: '.5em'}}/>
                <Button icon="pi pi-refresh" style={{'float': 'right'}}/>
            </div>;

        return <User headerUser={headerUser}/>

    }
};